/**
 * API utility — resolves the backend base URL.
 *
 * In development (Bun server running locally), requests are same-origin so
 * relative paths like "/api/contact" work fine.
 *
 * In production the site is a static site on Render (radiece-website) while the
 * Bun API server runs as a separate web service (radiece-api.onrender.com).
 * We must use an absolute URL so the static site can reach the API service.
 */

// Injected at build time by Bun (set VITE_API_URL or the Bun equivalent).
// Falls back to the Render API service URL in production.
const PROD_API_BASE = "https://radiece-api.onrender.com";

function getApiBase(): string {
  // If running in development (same-origin Bun server), use relative paths
  if (typeof window !== "undefined" && window.location.hostname === "localhost") {
    return "";
  }
  // In production static site, point to the dedicated API service
  return PROD_API_BASE;
}

/**
 * Wrapper around fetch that automatically prepends the correct API base URL.
 * Usage: apiFetch("/api/contact", { method: "POST", ... })
 */
export async function apiFetch(path: string, init?: RequestInit): Promise<Response> {
  const base = getApiBase();
  const url = `${base}${path}`;
  return fetch(url, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      ...(init?.headers ?? {}),
    },
  });
}
